/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';
import { action } from '@ember/object';
import { ConditionType } from 'cio/utils/condition-types';
import ObjectTypeModel from 'cio/models/object-type';
import { dateOperators, inequalityOperators, stringOperators } from 'cio/utils/operators';

export enum RelationshipAttributesKey {
  relationshipAttributeTriggers = 'relationshipAttributeTriggers',
  relationshipFilters = 'relationshipFilters',
  triggerRelationshipFilters = 'triggerRelationshipFilters',
}

export interface RelationshipArgs {
  campaign: CampaignModel;
  relationshipAttributes: CampaignModel[RelationshipAttributesKey];
  relationshipAttributesKey: RelationshipAttributesKey;
  updateTopLevelValue: (key: RelationshipAttributesKey, value: CampaignModel[RelationshipAttributesKey]) => unknown;
  isTriggerBlock?: boolean;
  objectType: ObjectTypeModel;
  maxConditionCountBeforeThreshold?: number;
  isUpdateTypeCampaign: boolean;
  showSummary?: boolean;
  preferFilterOverCondition?: boolean;
  sidebarAddConditionDescription?: string;
}

export default class Config extends Component<RelationshipArgs> {
  readonly conditionTypes = Object.freeze([ConditionType.RelationshipAttribute]);
  readonly allowedConditionOperators = [...inequalityOperators, ...stringOperators, ...dateOperators].map(
    (op) => op.value,
  );

  get conditions() {
    return this.args.relationshipAttributes ?? [];
  }

  @action
  updateTriggers(filters: CampaignModel[RelationshipAttributesKey]) {
    this.args.updateTopLevelValue(this.args.relationshipAttributesKey, filters);
  }
}
